<template>
    <div class="base-panel">
        <div class="base-panel-head space-between">
            <div>离散率</div>
        </div>
        <div class="base-panel-body vertical-center">
            <template v-if="data.XTime.length > 0">
                <basic-echarts ref="inverterRatioChart" :height="'100%'"></basic-echarts>
            </template>
            <template v-else-if="data.XTime.length === 0">
                <a-empty style="padding-top: 30px" />
            </template>
        </div>
    </div>
</template>

<script>
    import BasicEcharts from "@/components/Echarts/BasicEcharts";
    export default {
        name: "inverterRatio",
        components:{
            BasicEcharts
        },
        data(){
            return {
                inverterId: 0,
                data:{
                    XTime:[],
                    rate: [],
                    i1:[],
                    i2:[],
                    i3:[],
                    i4:[],
                    i5:[],
                    i6:[],
                    i7:[],
                    i8:[],
                    i9:[],
                    i10:[],
                    i11:[],
                    i12:[],

                }
            }
        },
        methods:{
            initCharts(id){
                this.inverterId = id;
                this.loadCharts();
            },
            async loadCharts(){
                let result = await this.$http.get(this.$baseURL.inverterTodayCurrentURL(this.inverterId));
                this.data.XTime = [];
                this.data.rate = [];
                this.data.i1 = [];
                this.data.i2 = [];
                this.data.i3 = [];
                this.data.i4 = [];
                this.data.i5 = [];
                this.data.i6 = [];
                this.data.i7 = [];
                this.data.i8 = [];
                this.data.i9 = [];
                this.data.i10 = [];
                this.data.i11 = [];
                this.data.i12 = [];

                if(result.length > 0){
                    result.forEach(item => {
                        this.data.i1.push(item.i1);
                        this.data.i2.push(item.i2);
                        this.data.i3.push(item.i3);
                        this.data.i4.push(item.i4);
                        this.data.i5.push(item.i5);
                        this.data.i6.push(item.i6);
                        this.data.i7.push(item.i7);
                        this.data.i8.push(item.i8);
                        this.data.i9.push(item.i9);
                        this.data.i10.push(item.i10);
                        this.data.i11.push(item.i11);
                        this.data.i12.push(item.i12);
                        this.data.XTime.push(item.createTime);
                        let average = (item.i1 + item.i2  + item.i3  + item.i4  + item.i5  + item.i6  + item.i7  + item.i8  + item.i9  + item.i10  + item.i11  + item.i12 ) / 12;
                        let deviation =  Math.sqrt( (Math.pow((item.i1 - average),2) +
                            Math.pow((item.i2 - average),2) +
                            Math.pow((item.i3 - average),2) +
                            Math.pow((item.i4 - average),2) +
                            Math.pow((item.i5 - average),2) +
                            Math.pow((item.i6 - average),2) +
                            Math.pow((item.i7 - average),2) +
                            Math.pow((item.i8 - average),2) +
                            Math.pow((item.i9 - average),2) +
                            Math.pow((item.i10 - average),2) +
                            Math.pow((item.i11 - average),2) +
                            Math.pow((item.i12 - average),2) ) / 12);
                        if(average === 0){
                            this.data.rate.push("-");
                        }else{
                            let rateData = deviation * 100 / average;
                            this.data.rate.push(rateData.toFixed(2));
                        }
                    });


                    //console.log(this.data.XTime);

                    let option = {
                        tooltip : {
                            trigger: 'axis',
                            formatter:function (params) {
                                let res = "";
                                let length = params.length;
                                for(let i = 0 ;i < length; i++){
                                    if(params[i].seriesIndex === 0){
                                        res += "离散率："+params[i].value + " % <br/>";
                                    }else if(params[i].seriesIndex === 1){
                                        res += "i1："+params[i].value + " A <br/>";
                                    }else if(params[i].seriesIndex === 2){
                                        res += "i2："+params[i].value + " A <br/>";
                                    }else if(params[i].seriesIndex === 3){
                                        res += "i3："+params[i].value + " A <br/>";
                                    }else if(params[i].seriesIndex === 4){
                                        res += "i4："+params[i].value + " A <br/>";
                                    }else if(params[i].seriesIndex === 5){
                                        res += "i5："+params[i].value + " A <br/>";
                                    }else if(params[i].seriesIndex === 6){
                                        res += "i6："+params[i].value + " A <br/>";
                                    }else if(params[i].seriesIndex === 7){
                                        res += "i7："+params[i].value + " A <br/>";
                                    }else if(params[i].seriesIndex === 8){
                                        res += "i8："+params[i].value + " A <br/>";
                                    }else if(params[i].seriesIndex === 9){
                                        res += "i9："+params[i].value + " A <br/>";
                                    }else if(params[i].seriesIndex === 10){
                                        res += "i10："+params[i].value + " A <br/>";
                                    }else if(params[i].seriesIndex === 11){
                                        res += "i11："+params[i].value + " A <br/>";
                                    }else if(params[i].seriesIndex === 12){
                                        res += "i12："+params[i].value + " A <br/>";
                                    }
                                }
                                let result = params[0].name + " <br/>"+  res;
                                return result;
                            }
                        },
                        legend: {
                            data:['离散率','i1','i2','i3','i4','i5','i6','i7','i8','i9','i10','i11','i12']
                        },
                        toolbox: {
                            show : false,
                            feature : {
                                mark : {show: true},
                                dataView : {show: true, readOnly: false},
                                magicType : {show: true, type: ['line', 'bar']},
                                restore : {show: true},
                                saveAsImage : {show: true}
                            }
                        },
                        calculable : false,
                        grid:{
                            top: '10%'
                        },
                        xAxis : [
                            {
                                type : 'category',
                                data : this.data.XTime
                            }
                        ],
                        yAxis : [
                            {
                                type : 'value',
                                position: 'left',
                                name:"电流",
                                axisLabel : {
                                    show:true,
                                    interval: 'auto',    // {number},
                                    formatter: '{value}A'
                                },
                                splitLine : {
                                    show: true,
                                    color: ['#ccc'],
                                    width: 1,
                                    type: 'dotted'
                                }
                            },
                            {
                                name:"离散率",
                                position:"right",
                                scale:true,
                                axisLabel : {
                                    show:true,
                                    interval: 'auto',    // {number}
                                    formatter: '{value}%'
                                },
                                splitLine : {
                                    show: true,
                                    color: ['#ccc'],
                                    width: 1,
                                    type: 'dotted'
                                }
                            }
                        ],
                        series : [
                            {
                                name:'离散率',
                                type:'line',
                                barMaxWidth:30,
                                yAxisIndex:1,
                                symbol: 'none',
                                data: this.data.rate,
                                smooth:false,
                                itemStyle: {
                                    normal: {
                                        lineStyle: {
                                            type: 'dotted'
                                        }
                                    }
                                }
                            },
                            {
                                name:'i1',
                                type:'line',
                                barMaxWidth:30,
                                yAxisIndex:0,
                                symbol: 'none',
                                data: this.data.i1
                            },
                            {
                                name:'i2',
                                type:'line',
                                barMaxWidth:30,
                                yAxisIndex:0,
                                symbol: 'none',
                                data: this.data.i2
                            },
                            {
                                name:'i3',
                                type:'line',
                                barMaxWidth:30,
                                yAxisIndex:0,
                                symbol: 'none',
                                data: this.data.i3
                            },
                            {
                                name:'i4',
                                type:'line',
                                barMaxWidth:30,
                                yAxisIndex:0,
                                symbol: 'none',
                                data: this.data.i4
                            },
                            {
                                name:'i5',
                                type:'line',
                                barMaxWidth:30,
                                yAxisIndex:0,
                                symbol: 'none',
                                data: this.data.i5
                            },
                            {
                                name:'i6',
                                type:'line',
                                barMaxWidth:30,
                                yAxisIndex:0,
                                symbol: 'none',
                                data: this.data.i6
                            },
                            {
                                name:'i7',
                                type:'line',
                                barMaxWidth:30,
                                yAxisIndex:0,
                                symbol: 'none',
                                data: this.data.i7
                            },
                            {
                                name:'i8',
                                type:'line',
                                barMaxWidth:30,
                                yAxisIndex:0,
                                symbol: 'none',
                                data: this.data.i8
                            },
                            {
                                name:'i9',
                                type:'line',
                                barMaxWidth:30,
                                yAxisIndex:0,
                                symbol: 'none',
                                data: this.data.i9
                            },
                            {
                                name:'i10',
                                type:'line',
                                barMaxWidth:30,
                                yAxisIndex:0,
                                symbol: 'none',
                                data: this.data.i10
                            },
                            {
                                name:'i11',
                                type:'line',
                                barMaxWidth:30,
                                yAxisIndex:0,
                                symbol: 'none',
                                data: this.data.i11
                            },
                            {
                                name:'i12',
                                type:'line',
                                barMaxWidth:30,
                                yAxisIndex:0,
                                symbol: 'none',
                                data: this.data.i12
                            }
                        ]
                    };
                    this.$nextTick(()=> {
                        this.$refs.inverterRatioChart.refresh(option);
                    })
                }


            }
        }
    }
</script>

<style scoped>

</style>
